import { Add } from "@mui/icons-material";
import { Stack, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { PictureUploadSubtypeResponse } from "../../../../types/actionModule/subtypes/pictureUploadSubtype";

export function PictureUploadEditorPreview(state: SubtypeState) {
    const { t } = useTranslation();

    const subtype = state.properties as Partial<PictureUploadSubtypeResponse>;
    const pictureDescription = subtype.pictureDescription;
    const exampleImageUrl = subtype.exampleImageUrl;

    return <Stack direction="column">
        {pictureDescription && <Typography variant="body1">{pictureDescription}</Typography>}
        {
            exampleImageUrl &&
            exampleImageUrl.length > 0 &&
            <img src={exampleImageUrl} style={{
                width: "100%",
                padding: 0,
                margin: 0,
                marginBottom: 10,
            }} />
        }
        <Box
            sx={{
                borderColor: "grey",
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "16px",
                padding: "30px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            }}
        >
            <Add /> {t("actionModules.subtypes.pictureUpload.previewTakePicture")}
        </Box>
    </Stack>;
}